import { Component, OnInit } from '@angular/core';
import {PlatformCommand} from "@shared/commands/command-base";
import {Api} from "@shared/constants/common-field.constants";
import {DialogModel} from "@shared/models/dialog.model";
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";

@Component({
    standalone: false,
    selector: 'particle-cbc-master-file-required-dialog-editor',
  templateUrl: './cbc-master-file-required-dialog-editor.component.html',
  styleUrls: ['./cbc-master-file-required-dialog-editor.component.scss']
})
export class CbcMasterFileRequiredDialogEditorComponent implements OnInit, IDialogView {

  data: DialogModel;
  item: any;
  fieldDefinition: any;

  cbcMasterFileRequiredDefaultValue: any;
  MasterFileRequiredOverwrite: any = false;
  overwrittenCellValue: any;

  constructor() { }

  ngOnInit(): void {
    this.item = this.data.input['item'];
    this.fieldDefinition = this.data.input['fieldDefinition'];
    this.cbcMasterFileRequiredDefaultValue = this.item.cells['CbCMasterFileRequiredDefaultValue'].displayText;
    const MasterFileRequiredOverwriteValue = this.item.cells['IsCbCMasterFileRequiredOverwritten'].displayText;
    this.overwrittenCellValue = this.item.cells['JT36'].displayText;
    if(MasterFileRequiredOverwriteValue === 'Yes'){
      this.MasterFileRequiredOverwrite = true;
    }
  }


  onOkClicked(): any {
    this.data.input.NextExecutionCommand = this.getNextExecutionCommand();
    this.data.input.HasUpdate = this.HasUpdate();
    return true;
  }

  getNextExecutionCommand(){
    const command = new PlatformCommand('UpdateCbCComplianceCommand', Api.DueDateTracker);
    command.setValue('MasterFileRequiredCell', true);
    command.setValue('ItemId', this.item.id);
    command.setValue('IsMasterFileRequired', this.overwrittenCellValue === 'Yes');
    command.setValue('MasterFileRequiredOverwritten', this.MasterFileRequiredOverwrite);
    command.setValue('StrategyType', 'UpdateMasterFileRequiredStrategy');
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private HasUpdate(): boolean {
    if(this.overwrittenCellValue !== this.item.cells['JT36'].displayText) return true;
    else if(this.MasterFileRequiredOverwrite !== this.ConvertBoolean(this.item.cells['IsCbCMasterFileRequiredOverwritten'].displayText)){
      return true;
    }
    return false;
  }

  private ConvertBoolean = (value: any): boolean => value === 'Yes';


}
